export const serializes = {
  array: (v) => v.join(),
};